const initialState = {
    isFetchingUsersCount: false,
    users: [],
    admins: [],
    selectedViewData: []
}

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_USERS':
            return { ...state, users: action.data };
        case 'RECEIVE_ADMINS':
            return { ...state, admins: action.data };
        case 'DELETE_USER_SUCCESS':
            return { ...state, users: state.users.filter(item => item.id !== action.id) };
        case 'DELETE_ADMIN_SUCCESS':
            return { ...state, admins: state.admins.filter(item => item.id !== action.id) };
        // case 'UPDATE_USER_SUCCESS':
        //     return { ...state, users: state.users.map(x => action.data.find(({ id }) => id === x.id) || x) }
        // case 'UPDATE_ADMIN_SUCCESS':
        //     return { ...state, admins: state.admins.map(x => action.data.find(({ id }) => id === x.id) || x) }
        case 'ADD_ADMIN_SUCCESS':
            const obj1 = state.admins;
            obj1.push(action.data)
            return { ...state, admins: obj1 }
        case 'ADD_USER_SUCCESS':
            const obj2 = state.users;
            obj2.push(action.data)
            return { ...state, users: obj2 }
        case 'SELECTED_ADMIN':
            return { ...state, selectedViewData: state.admins.filter(item => item.admin_user_id === action.data.admin_user_id) };
        case 'SELECTED_USER':
            
            return { ...state, selectedViewData: state.users.filter(item => item.admin_user_id === action.data.admin_user_id) };
        default:
            return state;
    }
}

export default dashboardReducer;